import { Alert, Intent, Position, Toaster } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

export type ScenarioArchiveAction = "archive" | "unarchive";

export const ScenarioArchiveToaster = Toaster.create({
    position: Position.TOP
});

const confirmButtonSubject = (count: number): string =>
    count === 1 ? "scenario" : `${count} scenarios`;

const alertSubject = (count: number): string =>
    count === 1 ? "this scenario" : `these ${count} scenarios`;

const alertBody = (action: ScenarioArchiveAction, count: number): string =>
    action === "archive"
        ? `Are you sure you want to archive ${alertSubject(
              count
          )}? Archived scenarios are hidden by default.`
        : `Are you sure you want to unarchive ${alertSubject(
              count
          )}? Unarchived scenarios are shown by default.`;

export const ScenarioArchiveAlert: React.FC<{
    action: ScenarioArchiveAction;
    /** Number of scenarios the confirmation covers */
    count: number;
    isOpen: boolean;
    isLoading: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}> = ({ action, count, isOpen, isLoading, onCancel, onConfirm }) => {
    const isArchive = action === "archive";

    return (
        <Alert
            cancelButtonText="Cancel"
            confirmButtonText={`${
                isArchive ? "Archive" : "Unarchive"
            } ${confirmButtonSubject(count)}`}
            icon={isArchive ? IconNames.ARCHIVE : IconNames.UNARCHIVE}
            intent={isArchive ? Intent.WARNING : Intent.NONE}
            isOpen={isOpen}
            loading={isLoading}
            onCancel={onCancel}
            onConfirm={onConfirm}
        >
            <p>{alertBody(action, count)}</p>
        </Alert>
    );
};
